<template>
  <div
    @click="$emit('onClick')"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
    class="w-full flex cursor-pointer justify-end content-start"
  >
    <button
      class="w-full flex justify-end items-center focus:outline-none text-sm uppercase"
      :class="customCssButton"
      :disabled="disabled"
      :type="type"
      :id="id"
    >
      <slot>
        CustomButton
      </slot>
    </button>
    <div
      class="w-10 flex items-center pl-2 justify-end"
    >
      <div
        :class="customCssLine"
        class="border-b transition-all ease-in-out duration-300"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomButtonFour',
  props: {
    id: String,
    type: {
      type: String,
      default: 'button'
    },
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hovered: false
    }
  },
  computed: {
    customCssButton: function () {
      var toReturn = ''
      if (this.dark) toReturn += ' text-black '
      else toReturn += ' text-white  '

      return toReturn
    },
    customCssLine: function () {
      var toReturn = ''

      if (this.dark) toReturn += ' border-black'
      else toReturn += ' border-white '

      if (!this.disabled) {
        if (!this.hovered) {
          toReturn += ' w-2 '
        } else {
          toReturn += ' w-6 '
        }
      }
      return toReturn
    }
  }
}
</script>
